export default {
  isOnboarded: [],
  systemNotifications: []
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/onboarding/state.js
// module id = null
// module chunks = 